/**
 * Feature flags evaluated server-side in withServerSideProps and bubbled to
 * every page via useGlobalContext().featureFlags.
 *
 * Prefer this over featureFlagContext.client.variation() in client components:
 * server-side eval is correct on first render (no flicker) and matches the LD
 * context used by getServerSideProps redirects.
 *
 * To migrate a client-side variation() call, add a field here, evaluate it in
 * resolveGlobalFeatureFlags (./globalFeatureFlags.server), then have the
 * component read from globals.
 *
 * This file is client-safe — it contains no server-only imports so it can be
 * imported by GlobalContext and other code that ships to the browser bundle.
 *
 * When to add a flag here vs. evaluating per-page:
 *   - Add here ONLY if the flag is consumed by code that renders on every page
 *     (sidebar, nav, layout chrome, base selectors) and therefore can't easily
 *     receive it via per-page props.
 *   - For flags consumed by a specific page or its components, evaluate in
 *     that page's onPageRequest and pass via page props. Same SSR benefit
 *     (no flicker), but the cost is scoped to the page that needs it.
 *
 * Every flag added here pays a small cost on every page render (SSR props
 * payload, test/story mock updates, decorator coupling). Keep this list
 * narrow on purpose.
 */
export type GlobalFeatureFlags = {
  isAdvancedDiscountV2Enabled: boolean
  isStockAvailabilityEnabled: boolean
  paxReceiptSettingsEnabledBaseXRefIDs: string[]
}

export const DEFAULT_GLOBAL_FEATURE_FLAGS: GlobalFeatureFlags = {
  isAdvancedDiscountV2Enabled: false,
  isStockAvailabilityEnabled: false,
  paxReceiptSettingsEnabledBaseXRefIDs: [],
}
